import { useQuery } from '@tanstack/react-query';
import { MapPinIcon } from '@heroicons/react/24/outline';
import { fairLendingApi } from '../lib/api';
import { useTeamId } from '../hooks/useTeamId';
import BranchesPanel from '../components/branches/BranchesPanel';

export default function BranchesPage() {
  const { teamId } = useTeamId();
  const { data } = useQuery({
    queryKey: ['branches', teamId],
    queryFn: async () => {
      const res = await fairLendingApi.getBranches(teamId!);
      return res.data;
    },
    enabled: !!teamId,
  });

  const branchCount = data?.branches?.length ?? 0;

  return (
    <div className="max-w-5xl mx-auto">
      <div className="mb-6 flex items-start gap-3">
        <div className="rounded-lg bg-ocean-50 p-2 text-ocean-600">
          <MapPinIcon className="h-6 w-6" />
        </div>
        <div className="flex-1">
          <h1 className="text-2xl font-bold text-gray-900">Branches</h1>
          <p className="text-sm text-gray-600 mt-1">
            Branch and LPO data drives R12 redlining analysis and CRA assessment-area validation.
            {branchCount > 0 && <> Currently <span className="font-medium text-gray-900">{branchCount}</span> {branchCount === 1 ? 'branch' : 'branches'} on file.</>}
          </p>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <BranchesPanel />
      </div>
    </div>
  );
}
